import { Component, ViewEncapsulation } from '@angular/core';

/**
* This is the initial component or root component, it contains global loader for module and router-outlet to load the child component
*/
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent {
  title = 'cc-careAlly';
  constructor(){
    let url = window.location.href;
    if(url.includes('/app/')){
      url = `/app${url.split('/app').pop()}`;
      sessionStorage.setItem('deeplink', url);
    }
  }
}
